import { render, staticRenderFns } from "./CouponRuleList.vue?vue&type=template&id=84f8c2d6&scoped=true"
import script from "./CouponRuleList.vue?vue&type=script&lang=js"
export * from "./CouponRuleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f8c2d6",
  null
  
)

export default component.exports